export const SEDI_CONFIG = [
    {
        label: "Assemblea",
        descrizione: null,
        argomenti: [
            "Progetto di Costituzione (Discussione generale)", 
			"Disposizioni generali (Discussione generale)", 
			"Disposizioni generali (Discussione degli articoli da 1 a 7)", 
			"Titolo I: Rapporti civili (Discussione generale)", 
			"Titolo I: Rapporti civili (Discussione degli articoli da 8 a 22)", 
			"Titolo II: Rapporti etico-sociali (Discussione generale)", 
			"Titolo II: Rapporti etico-sociali (Discussione articoli)", 
			"Titolo III: Rapporti economici (Discussione generale)", 
			"Titolo III: Rapporti economici (Discussione articoli)", 
			"Titolo IV: Rapporti politici (Discussione generale)", 
			"Titolo IV: Rapporti politici (Discussione degli articoli da 45 a 51)", 
			"Titolo V: Le Regioni e i Comuni (Discussione generale)", 
			"Titolo V: Le Regioni e i Comuni (Discussione degli articoli da 106 a 108)", 
			"Titolo V: Le Regioni e i Comuni (Discussione degli articoli dal 108-bis al 124)", 
			"Titoli I, II e III: il Parlamento, il Capo dello stato, il Governo (Discussione generale)", 
			"Titolo I: il Parlamento (Discussione articoli)", 
			"Sull'elezione del Senato (articoli 57-59)", 
			"Sui due rami del Parlamento (articoli 59-69)", 
			"Sul giuramento di fedeltà dei membri del Governo (articolo 74-bis)", 
			"Sulla formazione delle leggi (articoli 70-82)", 
			"Sull'Assemblea nazionale (articolo 52)", 
			"Sull'amnistia e l'indulto (articolo 75)", 
			"Sull'elezione del capo dello Stato (articolo 79)", 
			"Per la formazione delle leggi (articolo 71)", 
			"Sulle funzioni e prerogative del Presidente della Repubblica (articoli 83-91)", 
			"Sul Governo (articoli 88-96)", 
			"Gli organi ausiliari del Governo", 
			"Norma transitoria sul diritto di voto degli ex fascisti", 
			"Sulle circoscrizioni regionali", 
			"Titolo IV: La Magistratura; e VI: Garanzie costituzionali (Discussione generale)", 
			"Titolo IV: La Magistratura", 
			"Titolo VI: Garanzie costituzionali (articoli dal 126 al 131)", 
			"Titolo V: Le Regioni e i Comuni (articoli 117, 118, 122, 125)", 
			"Secondo comma dell' art. 50 (Discussione)", 
			"Disposizioni finali e transitorie (Discussione generale)", 
			"Coordinamento degli articoli approvati nel progetto di Costituzione della Repubblica italiana", 
			"Su quattro articoli aggiuntivi relativi alla materia tributaria - art. 53 del testo definitivo (Discussione generale)"
        ],
    },
    {
        label: "Commissione per la Costituzione",
        descrizione: null,
        argomenti: [
            "Sui lavori della Commissione e delle Sottocommissioni",
			"Per il funzionamento della Commissione",
			"Per la documentazione della Commissione",
			"Per la redazione del progetto di Costituzione",
			"Disposizioni generali",
			"Disposizioni generali (Rapporti fra lo Stato e la Chiesa Cattolica)",
			"Disposizioni generali (Divieto di stampe e di altre manifestazioni di pensiero a tutela della morale pubblica)",
			"Disposizioni generali (Dei titoli nobiliari)",
			"Disposizioni generali (Responsabilità penale e pene)",
			"Diritti e doveri dei cittadini (Il diritto di sciopero)",
			"Diritti e doveri dei cittadini ( La famiglia)",
			"Diritti e doveri dei cittadini (Condizioni dei figli nati fuori del matrimonio)",
			"Diritti e doveri dei cittadini (Tutela dell'igiene e della sanità)",
			"II potere Legislativo (Elezione della Camera dei Senatori)",
			"II potere Legislativo (Elezione della Camera dei Deputati)",
			"II potere Legislativo ( 'Prorogatio' delle due camere)",
			"II potere Legislativo (Giuramento dei membri del Parlamento)",
			"II potere Legislativo (Conflitti fra le due Camere)",
			"II potere Legislativo (Referendum per l' entrata in vigore o per l'abrogazione di una legge)",
			"II potere Legislativo (Presidenza dell' Assemblea Nazionale)",
			"II potere Legislativo (Potere di amnistia dell' Assemblea Nazionale)",
			"II potere Legislativo (Voto di fiducia dell' Assemblea Nazionale al Governo)",
			"II potere Esecutivo (Elezione e rieleggibilità del Presidente della Repubblica)",
			"Il potere Esecutivo (Rieleggibilità del Capo provvisorio dello Stato)",
			"II potere Giudiziario (La Magistratura)",
			"Le Regioni le Province e i Comuni",
			"Garanzie costituzionali (La corte costituzionale)",
			"Disposizioni finali e transitorie ( Avocazione dei beni di casa Savoia)"
        ],
    },
    {
        label: "I Sottocommissione",
        descrizione: "(diritti e doveri dei cittadini)",
        argomenti: [
            "Sui lavori della Sottocommissione",
			"I principi dei rapporti civili",
			"I principi dei rapporti sociali (economici)",
			"I principi dei rapporti sociali (culturali)",
			"Sui lavori per la Costituzione",
			"Dichiarazioni di voto",
			"La famiglia",
			"I principi dei rapporti politici",
			"Lo Stato come ordinamento giuridico e i suoi rapporti con gli altri ordinamenti",
			"Sui lavori del Comitato di Coordinamento",
			"Revisione degli articoli da deferire al Comitato di Coordinamento",
			"La libertà di opinione, di coscienza e di culto",
			"Il giuramento",
			"L'insegnamento religioso nelle scuole elementari",
			"Chiusura dei lavori della Sottocommissione"
        ],
    },
    {
        label: "II Sottocommissione",
        descrizione: "(ordinamento costituzionale dello Stato)",
        argomenti: [
            "Sull'ordine dei lavori",
			"Sui lavori della Sottocommissione",
			"Autonomie locali",
			"Sull'ordine della discussione",
			"Sugli Statuti siciliano e sardo",
			"Ordinamento costituzionale dello Stato",
			"Consigli ausiliari e consiglio economico",
			"Coordinamento degli articoli sul potere Legislativo"
        ],
    },
    {
        label: "II Sottocommissione I Sezione",
        descrizione: "(potere esecutivo)",
        argomenti: [
            "Potere Esecutivo",
            "Rapporti di pubblico impiego",
            "Revisione della Costituzione"
        ],
    },
    {
        label: "II Sottocommissione II Sezione",
        descrizione: "(potere giudiziario)",
        argomenti: [
			"Potere Giudiziario",
            "Garanzie costituzionali"
        ],
    },
    {
        label: "III Sottocommissione",
        descrizione: "(diritti e doveri economico-sociali)",
        argomenti: [
            "Sui lavori della Sottocommissione",
			"Dovere sociale del lavoro e diritto al lavoro",
			"Diritto all'assistenza",
			"Garanzie economico-sociali per l'assistenza alla famiglia",
			"Garanzie economico-sociali del diritto all'affermazione della personalità del cittadino",
			"Sulla protezione della puerpera e del bambino",
			"Diritto di proprietà e intrapresa economica",
			"Diritto di associazione e ordinamento sindacale",
			"Controllo sociale dell'attività economica",
			"Coordinamento degli articoli approvati"
        ],
    },
    
];